class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.asidePanels = this.querySelectorAll('.mega-menu__aside-panel');
    this.primaryMenuLinks = this.querySelectorAll('.mega-menu__link--level-1');

    this.primaryMenuLinks.forEach((menuLink) => {
      menuLink.addEventListener(
        'click',
        this.handlePrimaryMenuClick.bind(this)
      );
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if(this.header.preventHide){
      // this is only for the case when there is only 1 menu item in the mega menu, in that case we want to open the aside panel by default when the mega menu is opened [DESKTOP-ONLY]
      const firstElement = this.mainDetailsToggle.querySelectorAll('.mega-menu__content .mega-menu__body ul.mega-menu__list li .mega-menu__link--level-1')[0];
      // if(this.mainDetailsToggle.querySelectorAll('.mega-menu__content .mega-menu__body ul.mega-menu__list li .mega-menu__link--level-1').length == 1 && !firstElement.classList.contains('is-active')){
      if(this.mainDetailsToggle.querySelectorAll('.mega-menu__content .mega-menu__body ul.mega-menu__list li .mega-menu__link--level-1.is-active').length == 0){
        const asideKey = this.mainDetailsToggle.querySelectorAll('.mega-menu__content .mega-menu__body ul.mega-menu__list li .mega-menu__link--level-1')[0].getAttribute('data-aside-target');
        firstElement.classList.add('is-active');
        this.showAsidePanel(asideKey);
      }
      // }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  handlePrimaryMenuClick(event) {
    const asideKey = event.currentTarget.dataset.asideTarget;
    const targetPanel = this.querySelector(`.mega-menu__aside-panel[data-aside="${asideKey}"]`);

    if (!asideKey || !targetPanel) return;

    event.preventDefault();

    this.hideAllAsidePanels();
    this.hideAllPrimaryMenuLinks();

    this.showAsidePanel(asideKey);
    this.showPrimaryMenuLink(event.currentTarget);
  }

  hideAllAsidePanels() {
    this.asidePanels.forEach((panel) => {
      panel.classList.remove('is-active');
    });
  }

  showAsidePanel(asideKey) {
    const asideContainer = this.querySelector('.mega-menu__aside');
    const megaMenuList = this.querySelector('.mega-menu__list');
    const megaMenuContent = this.querySelector('.mega-menu__content');

    if (!asideContainer || !megaMenuList) return;

    const asidePanel = this.querySelector(
      `.mega-menu__aside-panel[data-aside="${asideKey}"]`
    );

    let currentHeight = asideContainer.offsetHeight;

    if (!asidePanel) {
      requestAnimationFrame(() => {
        asideContainer.style.height = `${megaMenuList.offsetHeight || 0}px`;
      });
      return;
    }

    asidePanel.classList.add('is-active');
    megaMenuContent?.classList.add('aside-active');

    const newHeight = Math.max(
      asidePanel.scrollHeight,
      megaMenuList.offsetHeight
    );

    asideContainer.style.height = `${currentHeight}px`;
    asideContainer.style.transitionTimingFunction =
      newHeight > currentHeight ? 'ease-out' : 'ease-in';

    requestAnimationFrame(() => {
      asideContainer.style.height = `${newHeight}px`;
    });
  }

  hideAllPrimaryMenuLinks() {
    this.primaryMenuLinks.forEach((link) => {
      link.classList.remove('is-active');
    });
  }

  showPrimaryMenuLink(menuLink) {
    menuLink.classList.add('is-active');
  }
}

customElements.define('header-menu', HeaderMenu);
